"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _eventemitter = _interopRequireDefault(require("eventemitter3"));

var _openpgp = _interopRequireWildcard(require("openpgp"));

var _Identity = _interopRequireDefault(require("../Identity"));

var _random = require("../helpers/random");

var _sets = _interopRequireDefault(require("../RuleSet/sets"));

var rotateKey = function rotateKey(key) {
  return "".concat(key, "a");
}; // TODO: hash


var _pack = function pack(data) {
  return {
    keys: data.keys,
    members: data.members.map(function (m) {
      return m.publicKey.armor();
    }),
    rules: data.rules,
    ruleSet: data.ruleSet
  };
};

var Channel =
/*#__PURE__*/
function (_EventEmitter) {
  (0, _inherits2["default"])(Channel, _EventEmitter);

  function Channel(data, transporter) {
    var _this;

    (0, _classCallCheck2["default"])(this, Channel);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Channel).call(this));
    _this._data = data;
    _this._transporter = transporter;
    _this._ruleEngines = _sets["default"];
    return _this;
  }

  (0, _createClass2["default"])(Channel, [{
    key: "update",
    value: function () {
      var _update = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee() {
        var _this$_data, self, members, _this$_data$keys, idKey, channelKey, data, output, options, outer, message, ruleSet, next;

        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$_data = this._data, self = _this$_data.self, members = _this$_data.members;
                _this$_data$keys = this._data.keys, idKey = _this$_data$keys.idKey, channelKey = _this$_data$keys.channelKey;
                _context.next = 4;
                return this._transporter.get(idKey);

              case 4:
                data = _context.sent;

                if (data) {
                  _context.next = 7;
                  break;
                }

                return _context.abrupt("return", []);

              case 7:
                _context.prev = 7;
                _context.next = 10;
                return _openpgp.message.readArmored(data);

              case 10:
                _context.t0 = _context.sent;
                _context.t1 = [channelKey];
                options = {
                  message: _context.t0,
                  passwords: _context.t1
                };
                _context.next = 15;
                return _openpgp["default"].decrypt(options);

              case 15:
                outer = _context.sent;
                _context.next = 18;
                return self.decrypt(outer.data, members);

              case 18:
                message = _context.sent;
                output = message;
                ruleSet = this._ruleEngines[this._data.ruleSet];
                _context.next = 23;
                return ruleSet(message, this._data);

              case 23:
                this.emit('message', message);
                _context.next = 30;
                break;

              case 26:
                _context.prev = 26;
                _context.t2 = _context["catch"](7);
                output = _context.t2;
                this.emit('messageError', _context.t2);

              case 30:
                this._data.keys.idKey = rotateKey(idKey);
                this._data.keys.channelKey = rotateKey(channelKey);
                _context.next = 34;
                return this.update();

              case 34:
                next = _context.sent;
                return _context.abrupt("return", [output].concat((0, _toConsumableArray2["default"])(next)));

              case 36:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[7, 26]]);
      }));

      function update() {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "send",
    value: function () {
      var _send = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee2(data) {
        var receivers,
            self,
            _this$_data$keys2,
            idKey,
            channelKey,
            inner,
            options,
            outer,
            _args2 = arguments;

        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                receivers = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : this._data.members;
                self = this._data.self;
                _this$_data$keys2 = this._data.keys, idKey = _this$_data$keys2.idKey, channelKey = _this$_data$keys2.channelKey;
                _context2.next = 5;
                return self.encrypt(data, receivers);

              case 5:
                inner = _context2.sent;
                options = {
                  message: _openpgp.message.fromText(inner),
                  passwords: [channelKey]
                };
                _context2.next = 9;
                return _openpgp["default"].encrypt(options);

              case 9:
                outer = _context2.sent;
                _context2.next = 12;
                return this._transporter.add(idKey, outer.data);

              case 12:
                return _context2.abrupt("return", this.update());

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function send(_x) {
        return _send.apply(this, arguments);
      }

      return send;
    }()
  }, {
    key: "pack",
    value: function pack() {
      var receiver = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._data.self;

      var packed = _pack(this._data);

      return this._data.self.encrypt(packed, [receiver]);
    }
  }, {
    key: "members",
    get: function get() {
      return this._data.members;
    }
  }], [{
    key: "create",
    value: function () {
      var _create = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee3(self) {
        var members,
            channel,
            key,
            _args3 = arguments;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                members = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : [];
                _context3.t0 = Channel;
                _context3.t1 = {
                  idKey: (0, _random.randomString)(),
                  channelKey: (0, _random.randomString)()
                };
                _context3.t2 = self;
                _context3.t3 = [new _Identity["default"](self.publicKey)];
                _context3.t4 = _toConsumableArray2["default"];
                _context3.next = 8;
                return Promise.all(members.map(function (key) {
                  return _Identity["default"].open(key);
                }));

              case 8:
                _context3.t5 = _context3.sent;
                _context3.t6 = (0, _context3.t4)(_context3.t5);
                _context3.t7 = _context3.t3.concat.call(_context3.t3, _context3.t6);
                _context3.t8 = {
                  dictator: self.fingerprint
                };
                _context3.t9 = {
                  keys: _context3.t1,
                  self: _context3.t2,
                  members: _context3.t7,
                  rules: _context3.t8,
                  ruleSet: 'dictatorship'
                };
                _context3.t10 = undefined;
                channel = new _context3.t0(_context3.t9, _context3.t10);
                _context3.next = 17;
                return channel.pack();

              case 17:
                key = _context3.sent;
                return _context3.abrupt("return", key);

              case 19:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      function create(_x2) {
        return _create.apply(this, arguments);
      }

      return create;
    }()
  }, {
    key: "load",
    value: function () {
      var _load = (0, _asyncToGenerator2["default"])(
      /*#__PURE__*/
      _regenerator["default"].mark(function _callee4(self, key, transporter) {
        var sender,
            channelDataRaw,
            channelData,
            channel,
            _args4 = arguments;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                sender = _args4.length > 3 && _args4[3] !== undefined ? _args4[3] : self;
                _context4.next = 3;
                return self.decrypt(key, [sender]);

              case 3:
                channelDataRaw = _context4.sent;
                _context4.t0 = channelDataRaw.data.keys;
                _context4.t1 = channelDataRaw.data.rules;
                _context4.t2 = channelDataRaw.data.ruleSet;
                _context4.next = 9;
                return Promise.all(channelDataRaw.data.members.map(function (member) {
                  return _Identity["default"].open(member);
                }));

              case 9:
                _context4.t3 = _context4.sent;
                _context4.t4 = self;
                channelData = {
                  keys: _context4.t0,
                  rules: _context4.t1,
                  ruleSet: _context4.t2,
                  members: _context4.t3,
                  self: _context4.t4
                };
                channel = new Channel(channelData, transporter);
                return _context4.abrupt("return", channel);

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      function load(_x3, _x4, _x5) {
        return _load.apply(this, arguments);
      }

      return load;
    }()
  }]);
  return Channel;
}(_eventemitter["default"]);

var _default = Channel;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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